module.exports = __webpack_public_path__ + "img/basic-residence-small.fd2e7fb8.png";